
import AppLabel from "@/components/InfoInput.vue";
import { User } from "@/models/user";
import Vue from "vue";

export default Vue.extend({
	props: {
		value: {
			type: Object as () => User,
			required: true
		},
		password: {
			type: String
		}
	},
	components: {
		AppLabel
	}
});
